import React from 'react';
import type { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import FormButtonsContainer from 'atom-components/form-buttons-container';
import SubmitButton from 'atom-components/form-fields-for-hook-form/submit-button';
import { SubmitAction } from 'feature-components/mark-response/mark-response-form/mark-response-form.schema';
import { controlledMarkStatuses } from 'helpers/domain-specific/mark-status.helpers';
import type { MarkStatus } from 'services/assist-api/entities/test-instance-response-mark/types';

export const saveButtonLabels = {
  draft: {
    saving: 'Saving Draft...',
    save: 'Save Draft Marking'
  },
  submit: {
    saving: 'Submitting Mark...',
    save: 'Submit Marking'
  }
};
const fieldName = 'submitAction';

type Props = {
  markStatus: MarkStatus;
  canEditMark: boolean;
  canAdministrateMark: boolean;
  isSavingOrAllocating: boolean;
};

export default function SaveButtons({
  markStatus,
  canEditMark,
  canAdministrateMark,
  isSavingOrAllocating
}: Props): ReactElement {
  const { formState, setValue, watch } = useFormContext();
  const { isSubmitting } = formState;
  const submittingOrSaving = isSubmitting || isSavingOrAllocating;

  const bothSaveButtonsDisabled = submittingOrSaving || controlledMarkStatuses.includes(markStatus);
  const saveDraftButtonDisabled = bothSaveButtonsDisabled || !canEditMark;
  const submitMarkingButtonDisabled =
    bothSaveButtonsDisabled || (!canAdministrateMark && !canEditMark);

  const submitAction = watch(fieldName);

  return (
    <FormButtonsContainer>
      <SubmitButton
        disabled={saveDraftButtonDisabled}
        onClick={(): void => {
          setValue(fieldName, SubmitAction.SaveDraftMarking);
        }}
      >
        {submittingOrSaving && submitAction === SubmitAction.SaveDraftMarking
          ? saveButtonLabels.draft.saving
          : saveButtonLabels.draft.save}
      </SubmitButton>
      <SubmitButton
        disabled={submitMarkingButtonDisabled}
        onClick={(): void => {
          setValue(fieldName, SubmitAction.SubmitMarking);
        }}
      >
        {submittingOrSaving && submitAction === SubmitAction.SubmitMarking
          ? saveButtonLabels.submit.saving
          : saveButtonLabels.submit.save}
      </SubmitButton>
    </FormButtonsContainer>
  );
}
